import { cn } from '@/lib/utils'
import { statusMeta } from '@/lib/inventoryFlow/strings'
import type { RequisitionKind, RequisitionStatus } from '@/lib/inventoryFlow/types'

export function StatusChip({ status, kind, className }: { status: RequisitionStatus; kind?: RequisitionKind; className?: string }) {
  const m = statusMeta(status, kind)
  return (
    <span className={cn('inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold', m.cls, className)}>{m.label}</span>
  )
}

/** First letter of an item in a coloured square — stock items carry no photos yet. */
export function ItemAvatar({ name }: { name: string }) {
  const letter = name.trim().charAt(0).toUpperCase() || '?'
  const hue = [...name].reduce((h, c) => (h * 31 + c.charCodeAt(0)) % 360, 7)
  return (
    <span
      aria-hidden
      className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg text-base font-bold text-white"
      style={{ backgroundColor: `hsl(${hue} 45% 45%)` }}
    >
      {letter}
    </span>
  )
}
